import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import MyDialog from '../Layout/myDialog'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogPublicadosContainer from '../../containers/Catalogo/dialogPublicados'
import DialogRubroContainer from '../../containers/Rubro/dialogRubro'
import { Row, Col } from 'react-flexbox-grid'
import Divider from '@material-ui/core/Divider'; 
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper';
import './catalogo.css'
import * as Notification from '../../components/Common/notification'
import ArticuloItem from '../Catalogo/itemArticulo'
import Lazyload from 'react-lazyload';
import InfiniteScroll from "react-infinite-scroll-component";

class CatalogoAgregarArticulo extends React.Component {

    constructor(props){
        super(props)

        this.state = {

        }

   
    }


    componentWillReceiveProps(nextProps){
        
    
        


      }


    over=null;
    overaux= null;   

    renderButtons = () => {
        return(
            <div>
              
              <Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnSearch}>Buscar</Button>
                    
                     {/*
                    <Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnClickBorrar}>BORRAR</Button>                                                           
                <Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnClickEditar}>EDITAR</Button>         */
                }
                {/*<Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnClickTrasladar} disabled={!this.props.trasladar} >TRASLADAR</Button>*/}
                {/*<Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnClickOcultar} disabled={!this.props.ocultar}>OCULTAR</Button>                                       
                <Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnClickPublicar} disabled={!this.props.publicar}>PUBLICAR</Button>
                <Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnClickArticulo}>ARTICULO</Button>
                    */
                }
                
            </div>
        )
    }


    dragStart(e) {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', this.dragged);
      }


    dragEnd(indexArray,e) {
        //indexArray trae los datos tanto del subrubro, como del rubro, para hacer el swap de los articulos
        let idSubrubro = indexArray[0]
        let idRubro = indexArray[1]

        // update state
        var from = Number(this.dragged.dataset.id);
        var to = Number(this.over);
    
        if (from!==to && to!==-1 && this.over !== undefined){
            if(this.props.canSwap === false){ return; }
            
            e.target.parentElement.style.borderColor= "" //le saco los bordes
            e.target.parentElement.style.borderWidth = "1px"
            
            this.overaux.lastChild.lastChild.style.borderColor= ""
            this.overaux.lastChild.lastElementChild.style.borderWidth = "1px" 
            
            
            this.props.handleOnChangeOrderCatalogoEntradaImagenes(from,to, idRubro,idSubrubro) // ya que utilizaremos los indices del array de imagenes
            
        }
        else{
            Notification.showError('Error al arrastrar. Intente nuevamente.')
            e.target.parentElement.style.borderColor= "" //le saco los bordes
            e.target.parentElement.style.borderWidth = "1px"
        }
      }


    dragOver(e) {
        e.preventDefault();//Esto es tan asi, porque el Col-3 que tiene el draggable, tiene muchas cosas adentro. El target llega hasta la img, pero necesita ir más arriba.
        
        if(e.target.className === 'placeholder') return;
        if(e.target.parentElement.parentElement.parentElement.dataset.id){
           
            this.over = e.target.parentElement.parentElement.parentElement.dataset.id; // El id
            this.overaux=e.target.parentElement.parentElement.parentElement; //Todo el elemento                      
                
            e.target.parentElement.style.borderColor =  "cyan" 
            e.target.parentElement.style.borderWidth =  "3px" 
            }        
        }
    
    render() {
        return (
            <div className='catalogo'>
                  
                
               {/* menú superior */}     

               
               {this.props.mostrarTitleBar?
               <TitleBar                     
                    title="Productos disponibles"
                    type='catalogAddEntries' 
                    searchPlaceholder='Ingrese nombre o código'
                                       
                    showSearch = {true}
                    trasladar = {this.props.trasladar}
                    catalogo = {this.props.catalogo}
                    handleOnSearch={this.props.handleOnSearch} 
                    handleOnBack={this.props.handleOnBack} 
                  
                    
                   
                />:''
               }


                {this.props.showDialogPublicar  ? 

                    <MyDialog cuerpo={'Esta por publicar el catálogo ' + this.props.catalogo.nombre }  botonConfirmar={'PUBLICAR'} handleOnConfirmar={(e) => this.props.handleOnPublicar(this.props.catalogo.idCatalogo)} handleOnCancelar = {this.props.handleOnCancelarPublicar}/>
                :
                ''
                }

                {this.props.showDialogOcultar  ? 

                    <MyDialog cuerpo={'Esta por ocultar el catálogo ' + this.props.catalogo.nombre }  botonConfirmar={'OCULTAR'} handleOnConfirmar={(e) => this.props.handleOnOcultar(this.props.catalogo.idCatalogo)} handleOnCancelar = {this.props.handleOnCancelarOcultar}/>
                :
                ''
                }

                {this.props.showDialogBorrar  ? 

                    <MyDialog cuerpo={'Esta por borrar el catálogo ' + this.props.catalogo.nombre }  botonConfirmar={'BORRAR'} handleOnConfirmar={(e) => this.props.handleOnBorrar(this.props.catalogo.idCatalogo)} handleOnCancelar = {this.props.handleOnCancelarBorrar}/>
                :
                ''
                }

                {this.props.showDialogTrasladar  ? 

                <MyDialog cuerpo={'Está por trasladar artículos con stock remanente a otro catálogo' }  botonConfirmar={'TRASLADAR'} handleOnConfirmar={(e) => this.props.handleOnShowPublicados()} handleOnCancelar = {this.props.handleOnCancelarTrasladar}/>
                :
                ''
                }

                {this.props.showDialogPublicados  ? 
                    <DialogPublicadosContainer handleCancelPublicadosDialog = {this.props.handleCancelPublicadosDialog} handleOnTrasladar = {this.props.handleOnTrasladar} catalogo= {this.props.catalogo}/>
                :
                ''
                }

                
                {this.props.showDialogRubros === true ?  <DialogRubroContainer 
                                                            handleCancelButton= {this.props.handleCancelButtonRubros} 
                                                            idCatalogo= {this.props.catalogo.idCatalogo}
                                                        /> : ''}
                
                


                <div className= 'SuperRubro'>                
                  {this.props.listadoArticulo !== undefined ? this.props.listadoArticulo.listaSuperRubros.map((sr,srIndex) =>{                      
                      return(
                          
                        <InfiniteScroll
                            dataLength={this.props.currentPage * this.props.pageSize}
                            next={this.props.fetchMoreArticulos}
                            hasMore={this.props.hasMoreArticulos}

                            
                            loader={<h4 style={{ textAlign: "center" }}>Cargando artículos...</h4>}
                            useWindow={ false }
                            endMessage={
                                <p style={{ textAlign: "center" }}>
                                <b>No hay más artículos.</b>
                                </p>
                            }
                        >                        
                        {
                          sr.listaRubros.map((rub,rubIndex)=>{
                            return(
                                <div>
                                    <div>{rub.nombre}</div>
                                    <Divider className='divider'/>   
                                    {
                                       rub.listaSubRubros.map((itemSubrubro,isIndex) => {
                                           return(
                                               <div>
                                                    {itemSubrubro.tieneEntradasActivas? 
                                                       <div className='stockItemRow'>
                                                           <div className="subRubros">{itemSubrubro.nombre}</div>
                                                           <Paper className='containerPaperArticulos'>
                                                           
                                                           <Row className='stockItemRowImages'>

                                                          
                                                               {itemSubrubro.listaArticulos.map((itemArticulo,iaIndex) => {                                                                    
                                                                   return(
                                                                       <div>
                                                                           
                                                                           {itemArticulo.activo && 
                                                                               <Lazyload height={525}>
                                                                               <ArticuloItem 
                                                                                   quitarProducto={false}
                                                                                   agregarProducto={true}
                                                                                   key = {itemArticulo.idArticulo}  
                                                                                   idSuperRubro = {sr.idSuperRubro}
                                                                                   isGenerico = {(sr.nombre === 'Generico' || sr.nombre === 'Genérico' || sr.idSuperRubro === 2) ? true : false}                                                                                  
                                                                                   itemArticulo={itemArticulo}
                                                                                   getImgArticulo={this.props.getImgArticulo} 
                                                                                   handleOnClickAgregarArticulo={(e)=>
                                                                                   
                                                                                   {this.props.handleOnClickAgregarArticulo(e,itemArticulo.idArticulo)}}
                                                                                   handleOnClickCancelarEliminarArticulo={this.props.handleOnClickCancelarEliminarArticulo}
                                                                                   imagenesArticulos={this.props.imagenesArticulos.find(x=>x.idArticulo===itemArticulo.idArticulo)} 
                                                                                   
                                                                                   />
                                                                               </Lazyload>
                                                                           }
                                                                       </div>
                                                                   )
                                                               })}
                                                           
                                                           </Row>
                                                     
                                                           </Paper>
                                                       </div>: ''}   
                                               </div>
                                           )
                                       })}
                                </div>
                            )   
                         })

                        }
                        </InfiniteScroll>                            
        
                      )
                  }) : ''}
                </div>

                  {/* Eliminar */}
        <Dialog
        
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        open={this.props.modalConfirmarEliminacion}
        fullWidth={true}
        onClose={this.props.modalEliminarClose}
      >
        <DialogContent >

          <Row style={{margin: '0px'}}>

            <Col xs={12} md={12} lg={12}  style={{padding: '0px'}}>
              <div className='containerModalEliminarEntrada'>

                <div className='labelTitle'>ELIMINAR ENTRADA</div>
          
                <div className='descripcion'>¿Está seguro que desea eliminar el producto del catálogo?</div>
                
                

                <div className='containerButtonsEliminarEntrada'>
                  <Button className='cancelar' onClick={this.props.handleOnClickCancelarEliminarArticulo}>
                    Cancelar
                  </Button>
                  <Button className='guardar' onClick={this.props.handleOnClickcConfirmarEliminarEntrada}>
                    Aceptar
                  </Button>
                </div>

              </div>

            </Col>
          </Row>
          
        </DialogContent>
        </Dialog>



{/*
                <div className="rubros">
                {this.props.catalogo.listaRubros !== undefined ? this.props.catalogo.listaRubros.map((c,i) => {
                         return (
                            <div>
                              <div>{c.nombre}</div>
                              <Divider className='divider'/>
                              {
                                c.listaSubRubros.map(itemSubrubro => {
                                  return(
                                    <div>  
                                    {itemSubrubro.tieneEntradasActivas? // Vemos si el subrubro tiene alguna entrada activa, si tiene lo renderizamos, sino no.
                                    <div className='stockItemRow'>                                       
                                        <div className="subRubros">{itemSubrubro.nombre}</div>
                                        <Divider className='divider'/>
                                        <Paper onDragOver={this.dragOver.bind(this)}>
                                        <Row className='stockItemRowImages'>
                                            {itemSubrubro.listaArticulos.map(itemArticulo => {
                                                  return(
                                                      <div>    
                                                          {itemArticulo.catalogoEntradaActivo && // Si llego aca, nomas renderizamos el articulo que pertenezca a entrada activa
                                                                <Col md={3} data-id={itemArticulo.orden} draggable='true'  onDragEnd={this.dragEnd.bind(this,[itemSubrubro.idSubrubro,c.idRubro])} onDragStart={this.dragStart.bind(this)}>
                                                                    <Lazyload height={525} >
                                                                        <ArticuloItem
                                                                            itemArticulo={itemArticulo}
                                                                            idCatalogo={this.props.catalogo.idCatalogo}
                                                                            getImgArticulo={this.props.getImgArticulo} 
                                                                        />
                                                                    </Lazyload>
                                                                </Col>
                                                        }                                                                                        
                                                      </div>
                                                  )  
                                            })}
                                        </Row>
                                        </Paper>
                                    </div>
                                    : ''}
                                    </div>
                                        )
                                })
                              }
                            </div>
                         )
                    }) : '' }
                </div>

                */}

        
            </div>
        )
    }
}

CatalogoAgregarArticulo.propTypes = {
    catalogo: PropTypes.object.isRequired,
    publicar : PropTypes.bool.isRequired,
    showDialogPublicar : PropTypes.bool.isRequired,

    getImgArticulo: PropTypes.func.isRequired,
}

CatalogoAgregarArticulo.defaultProps = {
    catalogo: []
}

export default CatalogoAgregarArticulo
